import request from '@/utils/request'

/**
 * 查询家政服务列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingServs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.queryAdminServ',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加家政服务
 * @param {Object} data 服务数据
 * @returns {Promise} Promise对象
 */
export function addHousekeepingServ(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.saveServ',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新家政服务
 * @param {Object} data 服务数据
 * @returns {Promise} Promise对象
 */
export function updateHousekeepingServ(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.updateHousekeepingServ',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if(res.code === 0){
        resolve(res)
      }else{
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除家政服务
 * @param {String} servId 服务ID
 * @returns {Promise} Promise对象
 */
export function deleteHousekeepingServ(servId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.deleteServ',
      method: 'post',
      data: { servId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取家政服务类型
 * @returns {Promise} Promise对象
 */
export function getHousekeepingTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.queryHousekeepingType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function getServList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.queryAdminServ',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}